import '../styles/RichTextContent.css'
import { useMemo } from 'react'
import { DynamicContentType, RichTextData } from '@bm-js/atlascloud-shared'
import { useMargin } from '../utils/hooks'
import {
  fontWeights,
  maxWidths,
  textAligns,
  textColors,
} from '../utils/typography'

type Props = {
  content: DynamicContentType<RichTextData>
}

export const RichTextContent = ({ content }: Props) => {
  const textClasses = useMemo(() => {
    const fontWeight =
      fontWeights[content.data.fontWeight || 'normal'] || 'font-normal'
    const textAlign = textAligns[content.data.alignment || 'left']
    const color = textColors[content.data.color || 'black'] || 'black'
    const maxWidth = maxWidths[content.data.maxWidth || ''] || ''
    return `${fontWeight} ${textAlign} ${color} ${maxWidth}`
  }, [content.data])

  const margin = useMargin(content)

  return (
    <div className={`richTextContent ${textClasses} ${margin}`}>
      <div dangerouslySetInnerHTML={{ __html: content.data.html }} />
    </div>
  )
}
